import React, { useEffect } from "react";
import NCallSchedular from "../../components/calendar/schedular";
import { useNavigate } from "react-router-dom";
import { useNCallContext } from "../../context/ncall-context";
import NoData from "../../components/noData";

const ClientCalendar = () => {
  const { getDepartments, state } = useNCallContext();

  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("logged-in-as") == "admin") {
      navigate("/admin");
    }
  }, []);

  useEffect(() => {
    if (state.departments.length === 0) {
      getDepartments();
    }
  }, []);

  return state.departments.length > 0 ? (
    <NCallSchedular />
  ) : (
    <NoData
      message={`Scheduler is not configured for the ${localStorage.getItem(
        "companyName"
      )}`}
    />
  );
};

export default ClientCalendar;
